import { render, staticRenderFns } from "./KBKLimitSelectorFilter.view.vue?vue&type=template&id=0f05d150&"
import script from "./KBKLimitSelectorFilter.view.vue?vue&type=script&lang=js&"
export * from "./KBKLimitSelectorFilter.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f05d150')) {
      api.createRecord('0f05d150', component.options)
    } else {
      api.reload('0f05d150', component.options)
    }
    module.hot.accept("./KBKLimitSelectorFilter.view.vue?vue&type=template&id=0f05d150&", function () {
      api.rerender('0f05d150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/dictionaries/limits/KBKLimitSelectorFilter.view.vue"
export default component.exports